export default __webpack_public_path__ + "assets/images/dca594a0bd9acd2eb809722626948e72.png";